interface Props {
  name: string;
  size?: number;
  className?: string;
}

function gradientFor(name: string): { from: string; to: string } {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash << 5) - hash + name.charCodeAt(i);
    hash |= 0;
  }
  const hue1 = Math.abs(hash) % 360;
  const hue2 = (hue1 + 40) % 360;
  return {
    from: `hsl(${hue1}, 65%, 35%)`,
    to: `hsl(${hue2}, 70%, 55%)`,
  };
}

export function Avatar({ name, size = 32, className }: Props) {
  const initials = name
    .split(' ')
    .filter(Boolean)
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  const { from, to } = gradientFor(name);
  const fontSize = Math.round(size * 0.4);

  return (
    <span
      aria-hidden="true"
      className={'inline-flex items-center justify-center rounded-full font-semibold text-white ' + (className ?? '')}
      style={{
        width: size,
        height: size,
        fontSize,
        background: `linear-gradient(135deg, ${from} 0%, ${to} 100%)`,
      }}
    >
      {initials || '?'}
    </span>
  );
}
